const environment = {
  development: { isProduction: false },
  dev: { isProduction: false },
  production: { isProduction: true },
  prod: { isProduction: true },
}[process.env.NODE_ENV || 'development'];

export default {
  ...environment,
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: process.env.APIPORT,
  app: {
    title: 'title',
  },
};



// WEBPACK FOOTER //
// ./src/config.js